import { usePaymentStatus } from '../hooks/usePaymentStatus'

type TPaymentStatus = ReturnType<typeof usePaymentStatus>['paymentStatus']

/**
 * Gets gateway urls from the payment status.
 */
export const getGatewayUrls = (paymentStatus: TPaymentStatus) => {
  if (!paymentStatus) {
    return null
  }

  const {
    CSOBPaymentGatewayUrl,
    goPayPaymentGatewayUrl,
    payFastPaymentGatewayUrl,
    payUPaymentGatewayUrl,
    globalPaymentsPaymentGatewayUrl,
  } = paymentStatus

  return {
    CSOBPaymentGatewayUrl,
    globalPaymentsPaymentGatewayUrl,
    goPayPaymentGatewayUrl,
    payFastPaymentGatewayUrl,
    payUPaymentGatewayUrl,
  }
}
